import type { Client } from '~/types/models';

type ClientOwnedRecord = {
    clientId?: string;
    clientName?: string;
    client?: string;
};

type ClientOwnershipLabelMaps = {
    clientNameById?: Record<string, string>;
};

function normalizeText(value: unknown): string {
    return String(value || '').trim();
}

export function resolveOwnedClientId(
    record?: ClientOwnedRecord | null,
): string | undefined {
    const clientId = normalizeText(record?.clientId);
    return clientId || undefined;
}

export function matchesOwnedClient(
    record: ClientOwnedRecord,
    selectedClientId: string,
): boolean {
    const normalizedSelectedClientId = normalizeText(selectedClientId);
    if (!normalizedSelectedClientId) {
        return true;
    }

    return resolveOwnedClientId(record) === normalizedSelectedClientId;
}

export function clientOwnershipLabel(
    record: ClientOwnedRecord,
    options: ClientOwnershipLabelMaps = {},
): string {
    const resolvedClientId = resolveOwnedClientId(record);
    if (resolvedClientId) {
        return options.clientNameById?.[resolvedClientId]
            || normalizeText(record.clientName)
            || normalizeText(record.client)
            || resolvedClientId;
    }

    return normalizeText(record.clientName)
        || normalizeText(record.client)
        || 'Unlinked';
}

export function buildClientSelectOptions(
    clients: Array<Pick<Client, 'id'> & Partial<Pick<Client, 'name' | 'companyName'>>> = [],
): Array<{ value: string; label: string }> {
    return clients
        .map((client) => ({
            value: normalizeText(client.id),
            label: normalizeText(client.companyName) || normalizeText(client.name) || normalizeText(client.id),
        }))
        .filter((option) => option.value && option.label);
}
